<template>
  <v-layout>
    <v-flex>
      <v-card class="pa-6 pt-4 mt-10">
        <v-card-title>
          Received
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="table-search"
            label="Search"
            hide-details>
          </v-text-field>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="bookings"
          :server-items-length="pagination.total"
          :items-per-page="pagination.per_page"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
          :loading="loading"
          loading-text="Loading Received Items..."
          item-key="id"
          no-data-text="No Received Items Found"
          :options.sync="options"
          ref="table">

          <template v-slot:[`item.shipping_mark`]="{ item }">
            <v-icon
              size="24"
              class="mr-2">
              {{ isShipmentForSea(item.shipment_type) ? 'mdi-ferry' : 'mdi-airplane' }}
            </v-icon>
            {{ item.shipping_mark }}
          </template>

          <template v-slot:[`item.qty`]="{ item }">
            {{ formatNumber(item.qty) }}
          </template>

          <template v-slot:[`item.cbm`]="{ item }">
            <span v-if="isShipmentForSea(item.shipment_type)">{{formatNumber(item.cbm) }} CBM</span>
            <span v-if="!isShipmentForSea(item.shipment_type)">{{formatNumber(item.kg) }} KG</span>
          </template>

          <template v-slot:[`item.sales_agent`]="{ item }">
            <v-icon
              size="24"
              class="mr-1">
              mdi-face-agent
            </v-icon>
            {{ item.sales_agent }}
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <BookingStatusLabel :status="item.status" :small="true" :statuses="statuses"></BookingStatusLabel>
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment("MM-D-YYYY") }}
          </template>

          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="primary"
                  @click="viewItem(item.id)">
                  mdi-file-document-outline
                </v-icon>
              </template>
              <span>View</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import BookingStatusLabel from '@/components/BookingStatusLabel.vue'

  export default {
    name: 'ReceivedItemPage',
    data() {
      return {
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        firstLoad: true,
        loading: false,
        search: '',
        awaitingSearch: false,
        statuses: [],
        bookings: [],
        pagination: {
          page: 1,
          per_page: 1,
          total: 0,
          next: 0
        },
        options: {},
        headers: [
          {
            text: 'Shipping Mark',
            align: 'start',
            value: 'shipping_mark',
            sortable: false
          },
          {
            text: 'Description',
            align: 'start',
            value: 'description',
            sortable: false
          },
          {
            text: 'Qty',
            align: 'right',
            value: 'qty',
            sortable: false
          },
          {
            text: 'Measure',
            align: 'right',
            value: 'cbm',
            sortable: false
          },
          {
            text: 'Sales Agent',
            align: 'start',
            value: 'sales_agent',
            sortable: false
          },
          {
            text: 'Status',
            align: 'center',
            value: 'status',
            sortable: false,
            width: 70,
          },
          {
            text: 'Action',
            value: 'action',
            sortable: false,
            width: 90
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['formatNumber', 'formatNumberAmount', 'forSea']),
    },
    watch: {
      options: {
        handler () {
          this.getBooking()
        },
        deep: true,
      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.options.page = 1
            this.getBooking()
            this.awaitingSearch = false;
          }, 1000);
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
      isShipmentForSea (shipment_type){
        return this.forSea(shipment_type, this)
      },
      getStatusName: function(id){
        let statuses = this.statuses.filter(status => {
          return status.id == id
        })
        if(statuses.length > 0){
          return statuses[0].name
        }
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?booking_statuses=true')
          .then(response => {
            this.statuses = response.data.booking_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      viewItem (id) {
        this.$router.push({ name: 'booking-view', params: { id: id } })
      },
      getBooking () {
        if (this.loading) {
          return false
        }

        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let sorting = []
        let params = []

        if (sortBy.length === 1 && sortDesc.length === 1) {
          sortBy.forEach(function (item, index) {
            let sort = 'ASC'
            if (!sortDesc[index]) {
              sort = 'DESC'
            }
            sorting.push(item+'='+sort)
          });
        }

        if (this.search.length > 0){
          params.push('&search='+this.search)
        }

        if(!this.firstLoad){
          this.$router.push({ name: 'delivery-received-page', params: { page: page }})
        }

        this.firstLoad = false

        this.loading = true
        let self = this
        this.$http.plain.get('/deliveries/received?page='+ page + '&per_page=' + itemsPerPage + params.join())
          .then(response => {
            this.bookings = response.data.bookings
            if (response.data.pagination) {
              let pagination = response.data.pagination
              this.pagination.total = pagination.count
            }
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      if(this.$route.params.page){
        this.options.page = parseInt(this.$route.params.page)
      }

      this.getDefaultData()
    },
    components: {
      SnackBar,
      BookingStatusLabel
    },
  }
</script>
